import { render, staticRenderFns } from "./licHistory.vue?vue&type=template&id=5d207e5a&scoped=true&"
import script from "./licHistory.vue?vue&type=script&lang=js&"
export * from "./licHistory.vue?vue&type=script&lang=js&"
import style0 from "./licHistory.vue?vue&type=style&index=0&id=5d207e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d207e5a",
  null
  
)

export default component.exports